module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    staticClass: "modal-relative",
    attrs: {
      "wide": false,
      "width": "520px"
    },
    on: {
      "close": _vm.closeModal
    }
  }, [_c('p', {
    staticClass: "required-notice"
  }, [_c('span', [_vm._v("*")]), _vm._v(" " + _vm._s(_vm.$t('general.mandatory-fields')))]), _vm._v(" "), (!_vm.$store.state.isOnSite) ? _c('div', [(!_vm.people[0].delivery && _vm.SITE_CONFIG.accomodations.show_site) ? _c('label', {
    class: 'uppercase ' + (_vm.$store.state.isOnSite ? '' : ''),
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.openModal(['SkiSchoolLocationMap', {
          markers: _vm.SITE_CONFIG.rental.coordinates
        }])
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('general.extradition-point')) + " "), _c('icon', {
    attrs: {
      "name": "info-blue-white-bg",
      "scale": 1.3
    }
  }), _vm._v(" "), (!_vm.$store.state.isOnSite) ? _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.people[0].delivery && _vm.SITE_CONFIG.accomodations.show_site) ? _c('div', {
    class: 'box places ' + (_vm.$store.state.isOnSite ? '' : '') + (_vm.showError('place') ? ' box-error' : '')
  }, [(!_vm.$store.state.isOnSite || _vm.site == 1) ? _c('div', [_c('icon', {
    attrs: {
      "name": "byn",
      "scale": 1.8
    }
  }), _vm._v(" " + _vm._s(_vm.$t('general.sites.valley')) + "\n        "), (!_vm.$store.state.isOnSite) ? _c('Checkbox', {
    attrs: {
      "label": '',
      "value": 1,
      "valuebinder": _vm.site
    },
    on: {
      "update:valuebinder": function($event) {
        _vm.site = $event
      }
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.$store.state.isOnSite || _vm.site == 2) ? _c('div', [_c('icon', {
    attrs: {
      "name": "berget",
      "scale": 1.8
    }
  }), _vm._v(" " + _vm._s(_vm.$t('general.sites.top')) + "\n        "), (!_vm.$store.state.isOnSite) ? _c('Checkbox', {
    attrs: {
      "label": '',
      "value": 2,
      "valuebinder": _vm.site
    },
    on: {
      "update:valuebinder": function($event) {
        _vm.site = $event
      }
    }
  }) : _vm._e()], 1) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.showTimePicker) ? _c('div', [_c('label', {
    staticClass: "uppercase"
  }, [_vm._v(_vm._s(_vm.$t('general.pick-time'))), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), (['vallasen', 'ulricehamn'].indexOf(_vm.SITE_CONFIG.site) !== -1) ? _c('p', [_vm._v("På grund av rådande restriktioner och er säkerhet har vi valt att begränsa antalet hyrutrustningar som lämnas ut vid en viss tidpunkt. Det är därför viktigt att ni här nedanför väljer den tid ni tänkt hämta er utrustning och är noga med att komma på utsatt tid.")]) : _vm._e(), _vm._v(" "), _c('div', {
    class: 'box checkboxes' + (_vm.showError('time') ? ' box-error' : '')
  }, _vm._l((_vm.times), function(time) {
    return _c('div', {
      class: (!time.available) ? 'disabled' : ''
    }, [_c('Checkbox', {
      attrs: {
        "label": (time.title),
        "sublabel": ((time.available && ['vallasen', 'ulricehamn'].indexOf(_vm.SITE_CONFIG.site) !== -1) ? ('' + time.available + ' kvar') : ''),
        "label-position": "after",
        "value": time.value,
        "valuebinder": _vm.pickupTime
      },
      on: {
        "update:valuebinder": function($event) {
          _vm.pickupTime = $event
        }
      }
    })], 1)
  }), 0)]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "uppercase"
  }, [_vm._v(_vm._s(_vm.$t('general.mobilephonenumber')) + " (" + _vm._s(_vm.$t('general.for-sms')) + ")"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    class: 'box phone' + (_vm.showError('phone') ? ' box-error' : '')
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    attrs: {
      "type": "tel"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "blur": _vm.fixPhone,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "phone-number"
  }, [_vm._v(_vm._s(_vm.$t('general.obs-format', {
    format: '+46701234567'
  })))])]), _vm._v(" "), (_vm.showReceiptPicker) ? _c('div', {
    staticClass: "receipt-wrapper"
  }, [_c('label', {
    staticClass: "uppercase"
  }, [_vm._v(_vm._s(_vm.$t('general.digital-receipt'))), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    class: 'box checkboxes' + (_vm.showError('receipt') ? ' box-error' : '')
  }, [_c('Checkbox', {
    attrs: {
      "label": _vm.$i18n.t('general.yes'),
      "label-position": "right",
      "value": true,
      "valuebinder": _vm.receipt
    },
    on: {
      "update:valuebinder": function($event) {
        _vm.receipt = $event
      }
    }
  }), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "label": _vm.$i18n.t('general.no'),
      "label-position": "right",
      "value": false,
      "valuebinder": _vm.receipt
    },
    on: {
      "update:valuebinder": function($event) {
        _vm.receipt = $event
      }
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.showInsurance) ? _c('div', {
    class: 'box insurance' + (_vm.showError('insurance') ? ' box-error' : '')
  }, [_c('h3', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.openPdf()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "avbestallning",
      "scale": 2
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('skirental.insurance.title'))), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" "), _c('icon', {
    attrs: {
      "name": "info-blue-white-bg",
      "scale": 1
    }
  })], 1)], 1), _vm._v(" "), (_vm.SITE_CONFIG.site === 'branas') ? _c('p', [_vm._v(_vm._s(_vm.$t('skirental.insurance.branas')))]) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.site === 'kungsberget') ? _c('p', [_vm._v(_vm._s(_vm.$t('skirental.insurance.kungsberget')))]) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.site === 'vallasen') ? _c('p', [_vm._v(_vm._s(_vm.$t('skirental.insurance.vallasen')))]) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.site === 'ulricehamn') ? _c('p', [_vm._v(_vm._s(_vm.$t('skirental.insurance.ulricehamn')))]) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.site === 'storstenshojden') ? _c('p', [_vm._v(_vm._s(_vm.$t('skirental.insurance.branas')))]) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.site === 'tolvmannabacken') ? _c('p', [_vm._v(_vm._s(_vm.$t('skirental.insurance.branas')))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "insurance-table"
  }, [_vm._l((_vm.people), function(person) {
    return (_vm.offerInsurance(person)) ? _c('div', {
      staticClass: "tr"
    }, [_c('div', {
      staticClass: "name"
    }, [_vm._v("\n          " + _vm._s(person.name) + "\n          "), _c('b', [_vm._v(_vm._s(_vm._f("currency")(_vm.insuranceSum(person))))])]), _vm._v(" "), _c('div', {
      staticClass: "checkboxes"
    }, [_c('Checkbox', {
      class: {
        error: _vm.markInsurance
      },
      attrs: {
        "label": _vm.$i18n.t('general.yes'),
        "label-position": "left",
        "value": true,
        "valuebinder": person.insurance
      },
      on: {
        "update:valuebinder": function($event) {
          return _vm.$set(person, "insurance", $event)
        }
      }
    }), _vm._v(" "), _c('Checkbox', {
      class: {
        error: _vm.markInsurance
      },
      attrs: {
        "label": _vm.$i18n.t('general.no'),
        "label-position": "left",
        "value": false,
        "valuebinder": person.insurance
      },
      on: {
        "update:valuebinder": function($event) {
          return _vm.$set(person, "insurance", $event)
        }
      }
    })], 1)]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "tr summarizer"
  }, [_c('div', [_c('span', [_vm._v(_vm._s(_vm.$t('skirental.insurance.total')))]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm._f("currency")(_vm.totalPrice)))])])])], 2)]) : _vm._e(), _vm._v(" "), (_vm.canUseCode && _vm.$store.state.isOnSite) ? _c('div', {
    staticClass: "box info"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('skirental.pay-cash')))])]) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.site === 'storstenshojden') ? _c('div', {
    staticClass: "box info"
  }, [_c('p', [_vm._v("Förbokad skidutrustning hämtas i skiduthyrningen i södra Storstenshöjden.")])]) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.site === 'vallasen' && _vm.onlySkipass) ? _c('div', {
    staticClass: "box info"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('skirental.only-skipass')))])]) : _vm._e(), _vm._v(" "), (_vm.productsAvailable === null) ? _c('div', {
    staticClass: "box info"
  }, [_c('p', [_vm._v("Kontrollerar tillgänglighet...")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [(_vm.canUseCode) ? _c('button', {
    class: 'small white border ' + (!_vm.validated ? 'disabled' : ''),
    on: {
      "click": function($event) {
        return _vm.openCodeModal()
      }
    }
  }, [_vm._v(_vm._s(_vm.$store.state.isOnSite ? _vm.$i18n.t('general.pay-cash') : _vm.$i18n.t('general.pay-with-code')))]) : _vm._e(), _vm._v("\n     \n    "), _c('button', {
    class: (!_vm.validated ? 'disabled' : '') + ' ' + 'margin-bottom',
    on: {
      "click": function($event) {
        return _vm.addToCart()
      }
    }
  }, [_vm._v(_vm._s(_vm.$store.state.isOnSite ? _vm.$t('general.pay-with-card') : _vm.$t('general.add-to-cart')))]), _vm._v(" "), (_vm.canUseCode && (_vm.SITE_CONFIG.site === 'vallasen' || _vm.SITE_CONFIG.site === 'ulricehamn') && _vm.$store.state.isOnSite) ? _c('button', {
    class: 'small white border ' + (!_vm.validated ? 'disabled' : ''),
    on: {
      "click": function($event) {
        return _vm.openCodeModal(true)
      }
    }
  }, [_vm._v(_vm._s(_vm.$i18n.t('general.pay-with-code')))]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b7281b6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/SkiRentalConfirm.vue
// module id = 931
// module chunks = 0